import React, { Component } from 'react';
import { getMenu, ClearAllWizard } from 'redux/actions/index';
import { fetchAlertCount } from 'redux/actions/Survey/SurveyAlerts';
import { Link } from 'react-router-dom';
import { withRouter } from "utils/withRouter";
import { connect } from 'react-redux';
import { ChevronLeft, ChevronRight, ChevronDown, PenTool } from 'lucide-react';

const LUCIDE_ICONS = {
  Surveys: <PenTool size={18} color="#fff" />,
};
import ascentLogo from 'media/images/app-logo.png';
import ascentLogoIcon from 'media/images/app-logo-icon.png';

class SideBar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      navItemChildIsActive: false,
      navItemParentIsActive: false,
      navItemIds: Array.from(Array(1).keys()),
      navParentItemIds: Array.from(Array(1).keys()),
    };
    this._alertCountTimer = null;
    this._alertCountDenied = false;
  }

  componentDidMount() {
    if (this.props.clientId) {
      this.props.getMenu(this.props.clientId);
    }
    this.syncAlertCountPolling();

    var helpLink = document.querySelector("#help-link #s-ko-launch");
    const email = localStorage.getItem("user.email");
    const firstName = localStorage.getItem("user.firstName");
    const lastName = localStorage.getItem("user.lastName");
    const fullName = `${(firstName !== 'undefined' ? firstName : '')} ${(lastName !== 'undefined' ? lastName : '')}`;
    var recScript = 'openko19("' + fullName + '","' + (email !== 'undefined' ? email : '') + '");';
  }

  componentDidUpdate(prevProps) {
    if (this.props.clientId && this.props.clientId !== prevProps.clientId) {
      this.props.getMenu(this.props.clientId);
      // Access is re-evaluated per client, so clear the denial latch and restart
      // the poll (which refreshes the badge immediately) for the new tenant.
      this._alertCountDenied = false;
      this.stopAlertCountPolling();
    }

    // menuList arrives after mount, so re-check on every update rather than only
    // when clientId changes.
    this.syncAlertCountPolling();
  }

  componentWillUnmount() {
    this.stopAlertCountPolling();
  }

  // The badge is only meaningful to users whose menu carries the Survey "Alerts"
  // item, and that menu is driven by the same Survey.Analytics claim the API
  // enforces. Polling without it returned 403 every 60s for the life of the tab.
  hasAlertsMenuItem() {
    return Array.isArray(this.props.menuList)
      && this.props.menuList.some(item => item.description === 'Alerts');
  }

  syncAlertCountPolling() {
    if (this.props.clientId && this.hasAlertsMenuItem() && !this._alertCountDenied) {
      this.startAlertCountPolling();
    } else {
      this.stopAlertCountPolling();
    }
  }

  startAlertCountPolling() {
    if (this._alertCountTimer) {
      return;
    }

    this.pollAlertCount();
    this._alertCountTimer = setInterval(() => this.pollAlertCount(), 60000);
  }

  stopAlertCountPolling() {
    clearInterval(this._alertCountTimer);
    this._alertCountTimer = null;
  }

  async pollAlertCount() {
    const result = await this.props.fetchAlertCount();

    // An expired session needs a new sign-in and a missing claim needs a role
    // change; neither resolves by retrying, so latch off instead of reissuing
    // the call once a minute until the tab closes.
    if (result && result.denied) {
      this._alertCountDenied = true;
      this.stopAlertCountPolling();
    }
  }

  renderMenuChild(parentId, childMenus) {
    return (
      <>
        {childMenus.map((childsItem) => {
          let innerChild = this.props.menuList.filter(item => item.parentId === childsItem.id);
          if (innerChild && innerChild.length > 0) {
            return (
              <li key={childsItem.id} className="nav-item child">
                <a
                  href={childsItem.url}
                  onClick={() => this.handleSidebarEvents(true, false, childsItem.id)}
                  className={`nav-link ${this.state.navItemIds.includes(childsItem.id) ? 'open' : ''}`}
                >
                  <span className="nav-link-title">{childsItem.description}</span>
                  <ChevronDown
                    height="17"
                    width="17"
                    aria-hidden="true"
                    focusable="false"
                    className="css-tj5bde-Svg nav-svg"
                    color="#fff"
                  />
                </a>
                <div style={{ display: this.state.navItemIds.includes(childsItem.id) ? 'block' : 'none' }}>
                  <ul className="child-menu">
                    {innerChild.map((innerChildItem) => (
                      <li key={innerChildItem.id} className="nav-item">
                        <Link className="nav-link inner-child" to={innerChildItem.url}>
                          {innerChildItem.description}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            );
          } else {
            const isAlerts = childsItem.description === 'Alerts';
            const alertCount = this.props.alertCount;
            return (
              <li key={childsItem.id} className="nav-item">
                <Link
                  onClick={() => this.handleSidebarEvents(false, false, childsItem.id)}
                  className="nav-link"
                  to={childsItem.url}
                >
                  <span className="nav-link-title tw:flex tw:items-center tw:gap-2">
                    {childsItem.description}
                    {isAlerts && alertCount > 0 && (
                      <span style={{
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                        minWidth: 18, height: 18, padding: '0 4px',
                        fontSize: 10, fontWeight: 600, lineHeight: 1,
                        background: '#ef4444', color: '#fff', borderRadius: 9999,
                      }}>
                        {alertCount > 99 ? '99+' : alertCount}
                      </span>
                    )}
                  </span>
                </Link>
              </li>
            );
          }
        })}
      </>
    );
  }

  handleSidebarEvents = (IsnavItemChild, IsnavItemParent, navItemId) => {
    this.props.ClearAllWizard();
    if (!this.props.sidebarIsActive) {
      this.props.onSidebarToggle(true);
    }

    if (IsnavItemParent) {
      if (this.state.navParentItemIds.includes(navItemId)) {
        this.state.navParentItemIds = this.state.navParentItemIds.filter((nav) => nav !== navItemId);
      } else {
        this.state.navParentItemIds.push(navItemId);
      }
      this.setState({ navParentItemIds: this.state.navParentItemIds });
    }

    if (IsnavItemChild) {
      if (this.state.navItemIds.includes(navItemId)) {
        this.state.navItemIds = this.state.navItemIds.filter((nav) => nav !== navItemId);
      } else {
        this.state.navItemIds.push(navItemId);
      }
      this.setState({ navItemIds: this.state.navItemIds });
    }
  };

  render() {
    let parents = this.props.menuList.filter(item => item.parentId == null);
    return (
      <div id="sidebar">
        <div className="navbar-scroll-container tw:h-full">
          <div id="sidemenu-btn" className="menu-button" onClick={() => this.props.onSidebarToggle(false)}>
            <a className={`menu-button-link ${this.props.sidebarIsActive ? 'active' : ''}`}>
              {this.props.sidebarIsActive
                ? <ChevronLeft className="tw:h-5 tw:w-5" />
                : <ChevronRight className="tw:h-5 tw:w-5" />
              }
            </a>
          </div>

          <div className="sidebar-logo-parent">
            <div className="sidebar-logo">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  this.props.router.navigate("/");
                }}
              >
                {this.props.sidebarIsActive
                  ? <img className="ascent-logo" src={ascentLogo} alt="Ascent360 Logo" />
                  : <img className="ascent-logo-icon" src={ascentLogoIcon} alt="Ascent360 Logo" />
                }
              </a>
            </div>
          </div>

          <div className="navbar-content tw:h-full">
            <div id="sidenav">
              <ul id="side-menu">
                {parents.map((parentsItem) => {
                  let childMenus = this.props.menuList.filter(item => item.parentId === parentsItem.id);
                  let iconValue = parentsItem.description.trim().replace(/\s/g, '');

                  if (childMenus && childMenus.length > 0) {
                    return (
                      <div key={parentsItem.id} id="nav">
                        <div className="nav-item">
                          <a
                            onClick={() => this.handleSidebarEvents(false, true, parentsItem.id)}
                            className={`nav-link ${this.state.navParentItemIds.includes(parentsItem.id) ? 'open' : ''}`}
                          >
                            {LUCIDE_ICONS[iconValue]
                              ? <div className="nav-lucide-icon">{LUCIDE_ICONS[iconValue]}</div>
                              : <div className={`${iconValue}-icon`}></div>}
                            <div className="nav-link-info tw:ml-2">
                              {parentsItem.description}
                              <ChevronDown
                                height="17"
                                width="17"
                                aria-hidden="true"
                                focusable="false"
                                className="css-tj5bde-Svg"
                                color="#fff"
                              />
                            </div>
                          </a>
                          <div style={{ display: this.state.navParentItemIds.includes(parentsItem.id) ? 'block' : 'none' }}>
                            <span className="child-menu">
                              {this.renderMenuChild(parentsItem.id, childMenus)}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div key={parentsItem.id} id="nav">
                        <div className="nav-item">
                            <a
                              className="nav-link"
                            >
                              {LUCIDE_ICONS[iconValue]
                              ? <div className="nav-lucide-icon">{LUCIDE_ICONS[iconValue]}</div>
                              : <div className={`${iconValue}-icon`}></div>}
                              <div className="nav-link-info tw:ml-2">
                                {parentsItem.description}
                              </div>
                            </a>
                          <Link
                            className="nav-link"
                            to={parentsItem.url}
                            onClick={() => this.handleSidebarEvents(false, false, parentsItem.id)}
                          >
                            <div className={`${iconValue}-icon`}></div>
                            <div className="nav-link-info tw:ml-2">
                              {parentsItem.description}
                            </div>
                          </Link>
                        </div>
                      </div>
                    );
                  }
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    clientId: state.common.clientId,
    menuList: state.configuration.menuList,
    alertCount: state.survey?.alertCount ?? 0,
  }
}

export default connect(mapStateToProps, {
  getMenu,
  ClearAllWizard,
  fetchAlertCount,
})(withRouter(SideBar));
